"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.default = exports.ProductVariant = void 0;
require("./ProductVariant.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _renderObject = require("../../util/renderObject/renderObject");
var _Image = _interopRequireDefault(require("../Image/Image"));
var _Text = _interopRequireDefault(require("../Text/Text"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * ProductVariant component
 *
 * @method
 * @param { ProductVariantProps} props
 * @returns ProductVariant
 */

const ProductVariant = props => {
  const {
    externalMedia,
    swatchImage,
    variantTypeLabel,
    variantTypeDescription
  } = props;
  const componentClassName = (0, _classnames.default)('pal-c-ProductVariant');
  if (!variantTypeLabel && !variantTypeDescription && !swatchImage && !externalMedia) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName
  }, variantTypeLabel && /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: "label-sm"
  }, variantTypeLabel), externalMedia && (0, _renderObject.renderObject)(externalMedia), !externalMedia && (swatchImage === null || swatchImage === void 0 ? void 0 : swatchImage.imageUrl) && /*#__PURE__*/_react.default.createElement(_Image.default, {
    ariaHidden: true,
    desktopImage: swatchImage.imageUrl
  }), variantTypeDescription && /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: "label-sm"
  }, variantTypeDescription));
};

/**
 * Property type definitions
 * @typedef ProductVariantProps
 * @type {object}
 * @property {string} variantTypeLabel - sets the product variant label - Color:
 * @property {object} swatchImage - sets the swatch image before the description label
 * @property {string} variantTypeDescription - sets the description text for the product variant
 * @property {object} externalMedia - accepts external media object
 */
exports.ProductVariant = ProductVariant;
const propTypes = exports.propTypes = {
  /**
   * accepts an object of external media with business logic
   */
  externalMedia: _propTypes.default.object,
  /**
   * sets the swatch image object
   * See Image object for more detail ../Image/Image.jsx
   */
  swatchImage: _propTypes.default.object,
  /**
   * sets the product variant type label
   */
  variantTypeLabel: _propTypes.default.string,
  /**
   * sets the description text for the product variant
   */
  variantTypeDescription: _propTypes.default.string
};
ProductVariant.propTypes = propTypes;
var _default = exports.default = ProductVariant;